import { User } from '../../types'

export const getJourneyStepUserName = (user?: User) => user?.full_name ?? '-'
